module.exports = __webpack_public_path__ + "static/media/outsideBlind.c738effc.jpg";